import {AbstractDTO} from "frontend-core";
import {AgentToAdd} from "@/models/AgentToAdd";
import {ValidationRuleResult} from "frontend-core/dist/models/AbstractDTO";
import {UserRoleEnum} from "@/models/UserRoleEnum";

export class AgentToAddDto extends AbstractDTO {
    constructor(
        protected readonly model: AgentToAdd,
    ) {
        super(model);

        this.rules = {
            name: () => !!this.model.name || ["Введите имя"],
            login: () => !!this.model.login || ["Введите логин"],
            role: () => !!this.model.role || ["Укажите роль агента"],
            email: () => {
                let res: ValidationRuleResult = true;

                if (this.model.role === UserRoleEnum.curator
                    || this.model.role === UserRoleEnum.mentor
                    || this.model.role === UserRoleEnum.subCurator
                ) {
                    if (this.model.email.trim().length === 0) {
                        res = ["Укажите email"];
                    } else {
                        // eslint-disable-next-line no-useless-escape
                        const regex: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                        res = regex.test(this.model.email) || ["Проверьте правильность email"];
                    }
                }

                return res;
            },
            phone: () => {
                let res: ValidationRuleResult = true;

                if (this.model.role === UserRoleEnum.curator
                  || this.model.role === UserRoleEnum.mentor
                  || this.model.role === UserRoleEnum.subCurator
                ) {
                    if (this.model.phone.trim().length === 0) {
                        res = ["Укажите номер телефона"];
                    } else {
                        // eslint-disable-next-line no-useless-escape
                        const regex: RegExp = /^\d{11}$/;

                        res = regex.test(this.model.phone) || ["Номер телефона должен содержать только 11 цифр, пример: 89000000000"];
                    }
                }

                return res;
            },
            parentAgentId: () => !!this.model.parentAgentId || ["Укажите агента-родителя"],
            legacyUserId: () => {
                let res: ValidationRuleResult = true;

                if (this.model.legacyUserId !== null) {
                    res = (typeof this.model.legacyUserId === "number" && Number.isInteger(this.model.legacyUserId)) || ["Значение должно быть целым числом"]
                }

                return res;
            }
        }
    }

    serialize(): AgentToAddOuterDto {
        return {
            name: this.model.name,
            login: this.model.login,
            role: [this.model.role],
            email: this.model.email,
            phone: this.model.phone,
            parentAgentId: this.model.parentAgentId,
            legacyUserId: this.model.legacyUserId || null,
        }
    }
}

export type AgentToAddOuterDto = {
    name: string;
    login: string;
    role: string[],
    email: string;
    phone: string;
    parentAgentId: string;
    legacyUserId: number | null;
}

